const _throttle = require('lodash.throttle');
const _debounce = require('lodash.debounce');

window.addEventListener('load', () => {
    const svgRoot = document.querySelector('svg[data-progress-ring]');
    const progressPath = svgRoot?.querySelector('path[data-progress-path]');
    const headerPanel = document.querySelector('.header-panel');

    if (svgRoot && progressPath && headerPanel) {
        let elementToTrack = headerPanel;
        const originalElementToTrack = elementToTrack;
        const buttonWrapper = progressPath.closest('button');

        // measure the path
        const totalLength = progressPath.getTotalLength();
        progressPath.style.strokeDasharray = `${totalLength} ${totalLength}`;
        progressPath.style.strokeDashoffset = totalLength;

        let startScrollPosition = elementToTrack.offsetTop;
        let previousDocHeight = document.documentElement.scrollHeight;

        const setProgress = (percent) => {
            const bounded = Math.min(Math.max(percent, 0), 100);
            const offset = totalLength - (bounded / 100) * totalLength;
            progressPath.style.strokeDashoffset = offset;
        };

        let elementIntersected = false;
        let observer = null;

        const createObserver = () => {
            if (observer) observer.disconnect();
            observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        elementIntersected = true;
                        if (buttonWrapper) buttonWrapper.dataset.active = 'true';
                    } else {
                        elementIntersected = false;
                        if (buttonWrapper) buttonWrapper.dataset.active = 'false';
                    }
                });
            }, { rootMargin: '0px' });
            observer.observe(elementToTrack);
        };

        const updateElementToTrack = () => {
            const closestDiv = elementToTrack.closest('div[data-show-form-index]');
            if (closestDiv && closestDiv.dataset.showFormIndex !== '0') {
                const form = closestDiv.querySelector('form');
                if (form) {
                    elementToTrack = form;
                    startScrollPosition = elementToTrack.offsetTop;
                    createObserver();
                    return;
                }
            }
            elementToTrack = originalElementToTrack;
            startScrollPosition = elementToTrack.offsetTop;
            createObserver();
        };

        const handleScroll = _throttle(() => {
            if (!elementIntersected) return;

            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const rawPercent = ((scrollTop - startScrollPosition) / (docHeight - startScrollPosition)) * 100;
            setProgress(rawPercent);
        }, 50);

        const handleResize = _debounce(() => {
            // re-measure path in case the SVG scales
            const newLength = progressPath.getTotalLength();
            if (Math.abs(newLength - totalLength) > 0.5) {
                // if the length changed due to layout scaling, reapply dasharray
                progressPath.style.strokeDasharray = `${newLength} ${newLength}`;
            }
            updateElementToTrack();
            handleScroll();
        }, 100);

        createObserver();

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);

        if (buttonWrapper) {
            buttonWrapper.addEventListener('click', () => {
                document.documentElement.scrollIntoView({ behavior: 'smooth' });
            });
        }

        handleScroll();

        setInterval(() => {
            const currentDocHeight = document.documentElement.scrollHeight;
            if (currentDocHeight !== previousDocHeight) {
                previousDocHeight = currentDocHeight;
                handleResize();
            }
        }, 500);
    }
});
